// Built-in modules
import qs from "qs";

// Third-party libraries
import React, {
  useReducer,
  useEffect,
  useContext,
  useState,
  useMemo,
} from "react";
import { Link as DomLink } from "react-router-dom";
import toast from "react-hot-toast";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Skeleton,
  DialogActions,
  Button,
  Container,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Stack,
  Step,
  Stepper,
  StepLabel,
} from "@mui/material";

// Local modules
import { api, storage, functions, constants } from "../../../utils";
import {
  AppContext,
  BandsContext,
} from "../../../utils/stateHandlers/contexts";
import states from "../../../utils/stateHandlers/initialStates";
import {
  bandsReducer,
  productReducer,
} from "../../../utils/stateHandlers/reducers";
import formatting from "../../../utils/formatHelpers";
import BandsPrice from "../components/bandsComponents/BandsPrice";
import BandsFields from "../components/bandsComponents/BandsFields";
import BandsDetailsTable from "../components/bandsComponents/BandsDetailsTable";
import BandsTechnicalArticles from "../components/bandsComponents/BandsTechnicalArticles";
import CustomerTestimonials from "../components/CustomerTestimonials";
import ProductGalleryViewer from "../components/ProductGalleryViewer";
import filterAds from "../../../utils/helperFunction";
import useMediaQueryUtils from "../../../utils/mediaQueryUtils";
import RecentlyView from "./RecentlyView";
import RelatedItems from "./RelatedItems";
import BandStepper from "./BandStepper";
import placeHolder from "../../../assets/images/BuildRing_Generic_XLG.jpg";

// Stepper related
import { useTheme } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import CertDiamondSearchLanding from "../../diamonds/CertDiamondSearchLanding";

// Repklace with correct images
import FlatImage from "../../../assets/images/icons/filter_icons/icon_bandstyle_Flat.png";
import diamondPlaceHolder from "../../../assets/images/icons/icon-HS-sig.png";

import debounce from "lodash/debounce";
import HarmonyMetalInfoBox from "../components/HarmonyMetalInfoBox";

export default function Bands(props) {
  const isMdScreen = useMediaQueryUtils("md");
  const [product, setProduct] = useState("");
  const { authToken } = useContext(AppContext);

  const [miniFlipTried, setMiniFlipTried] = useState(false);
  const [miniFlipTried2, setMiniFlipTried2] = useState(false);
  const [imageErrorCount, setImageErrorCount] = useState(0);

  const [settingModalOpen, setSettingModalOpen] = useState(false);
  const [productState, productDispatch] = useReducer(
    productReducer,
    states.initialProductState
  );
  const [bandsState, bandsDispatch] = useReducer(
    bandsReducer,
    states.initialBandsState
  );
  const {
    pageLoaded,
    productInfo,
    style,
    images,
    icons,
    productFields,
    builder,
    complex,
    complex1,
    complex2,
    complex3,
    relatedProducts,
    advertisement,
    compatibleSettings,
    setting,
  } = bandsState;
  const productCode = props.match.params.ProductStyleCode;
  const twoPartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}`;
  const threePartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}/${props.match.params.ProductStyleCodeThirdPart}`;
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;
  const [loadingSetting, setLoadingSetting] = useState(false);
  const [loadingDiamond, setLoadingDiamond] = useState(false);
  const [initialLoadRun, setInitialLoadRun] = useState(false);
  const [isBuilder, setIsBuilder] = useState(false);
  const [isCoreStyle, setIsCoreStyle] = useState(false);
  const [activeBandStep, setActiveBandStep] = useState(0);

  const stoneProviderFlag = !["CUSTOMER", "NONE"].includes(
    productInfo["complex[1][1][1][source]"]
  );

  // Setting Adding Code
  const [diamondSelected, setDiamondSelected] = useState(false);
  const [changesOccuring, setChangesOccuring] = useState(false);
  // Stepper Info
  const stepsInfo = [
    { name: "Select a Band", image: FlatImage },
    {
      name: "Select a Setting",
      image: "https://api2.hooverandstrong.com/catalog_images/P41_W_SU_XLG.png",
    },
    { name: "Select a Diamond", image: diamondPlaceHolder },
  ];
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const theme = useTheme();

  function setDefaultBandsFormData(band) {
    var defaults = {};
    band.fields.forEach(function (field) {
      if (
        field.template === "field_with_units" &&
        field.name !== "builder[product]"
      ) {
        defaults[field.name] = field.default;
      } else if (field.name !== "builder[product]") {
        defaults[field.name] = field.default;
        defaults = {
          ...defaults,
          [field.name]: field.default,
        };
      }
    });
    defaults["builder[product]"] = band.product;
    defaults["builder[dimension]"] = band.dimension;
    defaults["description"] = band.description;
    defaults["builder[quantity_unit]"] = "EA";
    defaults["setting[product]"] = "";
    defaults["setting[dimension]"] = "";
    defaults["setting[carat_size]"] = "";
    defaults["setting[material]"] = "";
    defaults["setting[center_stone]"] = "";

    defaults = {
      ...defaults,
      "builder[product]": band.product,
      "builder[dimension]": band.dimension,
    };
    return defaults;
  }

  function updateDiamond(diamond) {
    setDiamondSelected(diamond);
    resetImageFlipper();
    bandsDispatch({
      type: "updateFields",
      field: "setting[center_stone]",
      payload: diamond.HooverStockId,
    });
  }

  function updateStepper(stepIndex) {
    setActiveBandStep(stepIndex);
  }

  function sortBandFields(fields) {
    const builderArray = [];
    const complexArray = [];
    const complex1Array = [];
    const complex2Array = [];
    const complex3Array = [];
    fields.forEach(function (field) {
      if (field.name.startsWith("builder")) {
        builderArray.push(field);
      } else if (field.name.startsWith("complex[1]")) {
        complex1Array.push(field);
      } else if (field.name.startsWith("complex[2]")) {
        complex2Array.push(field);
      } else if (field.name.startsWith("complex[3]")) {
        complex3Array.push(field);
      } else {
        complexArray.push(field);
      }
    });
    const sortedComplex1Array = addSortOrderToFields(complex1Array);
    const sortedComplex2Array = addSortOrderToFields(complex2Array);
    const sortedComplex3Array = addSortOrderToFields(complex3Array);
    bandsDispatch({
      type: "setBandFieldCategories",
      payload: {
        builder: builderArray,
        complex: complexArray,
        complex1: sortedComplex1Array,
        complex2: sortedComplex2Array,
        complex3: sortedComplex3Array,
      },
    });
  }

  function addSortOrderToFields(fields) {
    const newSortedFields = [];
    fields.forEach(function (field) {
      const newField = {
        ...field,
        SortOrder: field.name.endsWith("[material]")
          ? 1
          : field.name.endsWith("[width]")
          ? 2
          : field.name.endsWith("[finish]")
          ? 3
          : field.name.endsWith("[rhodium]")
          ? 4
          : field.name.endsWith("[pattern]")
          ? 5
          : field.name.endsWith("[type]")
          ? 6
          : field.name.endsWith("[source]")
          ? 7
          : field.name.endsWith("[quality]")
          ? 8
          : field.name.endsWith("[size]")
          ? 9
          : field.name.endsWith("[quantity]")
          ? 10
          : 100,
      };
      newSortedFields.push(newField);
    });

    return newSortedFields.sort((a, b) => a.SortOrder - b.SortOrder);
  }

  function getInitialPrice(bandDefaults) {
    if (authToken) {
      api.postRequest(`quickorder/price`, bandDefaults).then((response) => {
        bandsDispatch({ type: "setPrice", payload: response.data });
        bandsDispatch({ type: "setPriceLoaded", payload: true });
      });
    }
  }

  function getPrice() {
    if (authToken) {
      api.postRequest(`quickorder/price`, productInfo).then((response) => {
        bandsDispatch({ type: "updatePrice", payload: response.data });
        bandsDispatch({ type: "setPriceLoaded", payload: true });
        setImageErrorCount(0);
        if (
          productInfo["complex[1][1][1][stoneSpread]"] != "E" &&
          !productInfo["complex[1][band][endType]"] &&
          isCoreStyle
        ) {
          if (product == "A") {
            var endType = response.data.fields.filter(
              (field) => field.name === "complex[1][band][endType]"
            );
            endType = endType.length > 0 ? endType[0].default : "";
            bandsDispatch({
              type: "updateFields",
              field: "complex[1][band][endType]",
              payload: endType,
            });
          }
        } else if (product == "A" && !initialLoadRun && !isCoreStyle) {
          setChangesOccuring(true);
          bandsDispatch({
            type: "updateFields",
            field: "complex[1][1][1][quality]",
            payload:
              response.data.fields.filter(
                (field) => field.name === "complex[1][1][1][quality]"
              )[0]?.default || "",
          });
          bandsDispatch({
            type: "updateFields",
            field: "complex[1][1][1][quantity]",
            payload:
              response.data.fields.filter(
                (field) => field.name === "complex[1][1][1][quantity]"
              )[0]?.default || "",
          });
          setInitialLoadRun(true);
          setChangesOccuring(false);
        }
        resetImageFlipper();
        updateFields(response.data.fields);
      });
    }
  }

  const LoadingSkeleton = () => (
    <Stack direction="row" spacing={2}>
      <Skeleton variant="rectangular" width={90} height={90} />
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="25rem" />
        <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
      </Stack>
      <Skeleton variant="rectangular" width={30} height={30} />
    </Stack>
  );

  function resetImageFlipper() {
    setMiniFlipTried(false);
    setMiniFlipTried2(false);
  }

  function resetSelection() {
    setChangesOccuring(true);
    bandsDispatch({
      type: "setSetting",
      payload: { setting: states.initialBandsState.setting },
    });
    productInfo["setting[dimension]"] = "";
    productInfo["setting[product]"] = "";
    productInfo["setting[carat_size]"] = "";
    productInfo["setting[material]"] = "";
    bandsDispatch({
      type: "setBandDefaultsBulk",
      payload: productInfo,
    });
    resetDiamond();
    resetImageFlipper();
    setChangesOccuring(false);
  }

  function resetDiamond() {
    if (activeStep > 1) {
      setActiveStep(1);
    }
    setCompletedSteps(new Set([0, 1]));
    setDiamondSelected(false);
    resetImageFlipper();
    bandsDispatch({
      type: "updateFields",
      field: "setting[center_stone]",
      payload: "",
    });
  }

  function appendError(error) {
    const errorMessage = [];
    error.forEach((err) => errorMessage.push(err));
    return errorMessage;
  }

  function updateSetting(style) {
    setSettingModalOpen(false);
    setLoadingSetting(true);
    resetImageFlipper();
    const settingBody = {
      style: style,
    };
    api.getRequest("quickorder/setting/form", settingBody).then((res) => {
      if (res.isAxiosError) {
        const errorMessage = appendError(res.response.data.errors);
        toast.error(
          `There was an error processing your request. ${errorMessage.toString()}`
        );
        bandsDispatch({ type: "setPriceLoaded", payload: true });
        setLoadingSetting(false);
      } else {
        handleNext(false);
        setChangesOccuring(true);
        res.data.fields.forEach((field) => {
          if (field.name == "material") {
            field.name = "setting[material]";
            field.label = "Setting Material";
          }
          if (field.name == "carat_size") {
            field.name = "setting[carat_size]";
            field.label = "Size (ct - mm)";
          }
        });

        productInfo["setting[dimension]"] = res.data.setting.dimension;
        productInfo["setting[product]"] = res.data.setting.product;
        productInfo["setting[carat_size]"] = res.data.fields.filter(
          (item) => item.name === "setting[carat_size]"
        )[0].default;
        productInfo["setting[material]"] = res.data.fields.filter(
          (item) => item.name === "setting[material]"
        )[0].default;

        bandsDispatch({
          type: "setBandDefaultsBulk",
          payload: productInfo,
        });
        bandsDispatch({ type: "setSetting", payload: res.data });
        setChangesOccuring(false);
        setLoadingSetting(false);
      }
    });
  }

  function updateFields(fields) {
    const newFields = [];
    productFields.forEach((field) => {
      newFields.push(field.name.endsWith("[width]") ? field : null);
    });
    fields.forEach(function (field) {
      newFields.push(field.name.endsWith("[width]") ? null : field);
    });
    const filteredFields = Array.from(
      new Set(newFields.filter((field) => field !== null))
    );
    sortBandFields(filteredFields);
  }

  const debouncedFormPrice = useMemo(
    () =>
      debounce(() => {
        bandsDispatch({ type: "setPageLoaded", payload: false });
        bandsDispatch({ type: "setPriceLoaded", payload: false });
        api
          .getRequest("quickorder/form", {
            style: props.match.params.ProductStyleCodeThirdPart
              ? threePartStyleCode
              : props.match.params.ProductStyleCodeSecondPart
              ? twoPartStyleCode
              : productCode,
          })
          .then((response) => {
            // TODO - Remove - Toggle to true to test on all items
            setIsBuilder(response.data.isAddASettingCapable);
            setIsCoreStyle(response.data.isCoreStyle);
            setProduct(response.data.product);
            const bandsDefaults = setDefaultBandsFormData(response.data);
            bandsDispatch({
              type: "setBandDefaultsBulk",
              payload: bandsDefaults,
            });
            sortBandFields(response.data.fields);
            bandsDispatch({ type: "setBandInfo", payload: response.data });
            functions.storeRecentlyViewed(response.data);
            getInitialPrice(bandsDefaults);
            bandsDispatch({ type: "setPageLoaded", payload: true });
          });
      }, 1000),
    [] // Empty dependency array ensures this function is only created once
  );

  useEffect(() => {
    if (props.match.params.ProductStyleCode) {
      debouncedFormPrice();
    }

    return () => {
      debouncedFormPrice.cancel();
    };
  }, [props.match.params.ProductStyleCode, debouncedFormPrice]);

  useEffect(() => {}, [props.match.params.ProductStyleCode]);

  useEffect(() => {
    if (authToken && pageLoaded && !changesOccuring) {
      bandsDispatch({ type: "setPriceLoaded", payload: false });
      getPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo, changesOccuring]);

  //advertisements from Strapi
  useEffect(() => {
    const query = qs.stringify({
      populate: {
        One: {
          populate: "*",
        },
        Two: {
          populate: "*",
        },
        Three: {
          populate: "*",
        },
        Four: {
          populate: "*",
        },
        Five: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/detail-page-ad?${query}`).then((response) => {
      const ads = response.data.data.attributes;
      const randomAd = filterAds(ads);

      bandsDispatch({
        type: "setPageAd",
        payload: randomAd,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  //
  //
  // Stepper Related things
  //
  //
  const CustomStepIcon = ({ icon, active }) => {
    const isCompleted = completedSteps.has(icon - 1);
    return (
      <Box
        sx={{
          width: 50,
          height: 50,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          backgroundColor: isCompleted
            ? theme.palette.success.default
            : active
            ? theme.palette.primary.contrastText
            : theme.palette.secondary.dark,
          color: isCompleted
            ? theme.palette.success.default
            : active
            ? theme.palette.primary.main
            : theme.palette.secondary.light,
          fontSize: "1.5rem",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {isCompleted ? (
          <CheckIcon />
        ) : (
          <img
            src={stepsInfo[icon - 1].image}
            style={{
              width: 50,
              height: 50,
            }}
            onError={(e) => {
              e.target.src = placeHolder;
            }}
          />
        )}
      </Box>
    );
  };

  const handleNext = (moveNextStep) => {
    setCompletedSteps((prev) => new Set([...prev, activeStep]));
    if (moveNextStep) {
      setActiveStep((prev) => prev + 1);
      if (activeStep == 1) {
        storage.setSessionStorageItem("hsSelectedData", JSON.stringify([]));
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const handleBack = () => {
    setCompletedSteps((prev) => {
      const newSet = new Set(prev);
      newSet.delete(activeStep - 1);
      return newSet;
    });
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompletedSteps(new Set());
  };

  const renderMainArea = () => {
    return (
      <>
        {!pageLoaded ? (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <Container maxWidth="xl">
            {isMdScreen ? (
              <>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4" textAlign={"center"}>
                    {style}
                  </Typography>
                  <Typography textAlign={"center"} variant="body1">
                    {productInfo.description &&
                      formatting["decodeHtml"](productInfo.description)}
                  </Typography>
                </Stack>
              </>
            ) : null}
            <Grid
              container
              spacing={2}
              sx={{ marginBottom: "1rem", marginTop: "1rem" }}
            >
              <Grid item xs={12} md={5}>
                <Stack>
                  <ProductGalleryViewer
                    images={images}
                    styleName={style}
                    icons={icons}
                    isCoreStyle={isCoreStyle}
                    imageErrorCount={imageErrorCount}
                    setImageErrorCount={setImageErrorCount}
                    miniFlipTried={miniFlipTried}
                    setMiniFlipTried={setMiniFlipTried}
                    miniFlipTried2={miniFlipTried2}
                    setMiniFlipTried2={setMiniFlipTried2}
                  />
                  {(!icons || !icons.includes("NONHARM")) && (
                    <HarmonyMetalInfoBox />
                  )}
                  {!isMdScreen && (
                    <RelatedItems relatedProducts={relatedProducts} />
                  )}
                  {!isMdScreen && <RecentlyView />}
                </Stack>
              </Grid>
              <Grid item xs={12} md={4}>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4" marginTop={"4rem"}>
                    {style}
                  </Typography>
                  <Typography>
                    {productInfo.description &&
                      formatting["decodeHtml"](productInfo.description)}
                  </Typography>
                </Stack>
                <BandStepper
                  builder={builder}
                  complex={complex}
                  complex1={complex1}
                  complex2={complex2}
                  complex3={complex3}
                  product={product}
                  stoneProviderFlag={stoneProviderFlag}
                  productInfo={productInfo}
                  resetSelection={resetSelection}
                  setSettingModalOpen={setSettingModalOpen}
                  diamondSelected={diamondSelected}
                  isCoreStyle={isCoreStyle}
                  isBuilder={isBuilder}
                  setting={setting}
                  globalStepperActiveStep={activeStep}
                  activeBandStep={activeBandStep}
                  setActiveBandStep={setActiveBandStep}
                  globalStepperBack={handleBack}
                  globalStepperNext={handleNext}
                  globalStepperReset={handleReset}
                  resetDiamond={resetDiamond}
                  setMiniFlipTried={setMiniFlipTried}
                  setMiniFlipTried2={setMiniFlipTried2}
                />
              </Grid>
              <Dialog
                open={settingModalOpen}
                maxWidth="md"
                onClose={() => setSettingModalOpen(false)}
              >
                <DialogTitle>Pick A Setting</DialogTitle>
                <DialogContent>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        sm: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                        xl: "repeat(4, 1fr)",
                      },
                    }}
                  >
                    {bandsState.compatibleSettings &&
                      bandsState.compatibleSettings.map((setting) => (
                        <Stack
                          onClick={() => {
                            updateSetting(setting.style);
                          }}
                          spacing={1}
                          className="pointer"
                          key={setting.style}
                        >
                          <img
                            className="related-items"
                            alt="Related Product"
                            src={setting.images[0]}
                            width="200"
                            height="200"
                          />
                          <Typography
                            className="style-text center"
                            sx={{ fontSize: "1.6rem", fontWeight: "800" }}
                          >{`${setting.style}`}</Typography>
                          <Typography
                            className="style-text center"
                            sx={{ textAlign: "center", fontSize: "1.2rem" }}
                          >
                            {formatting["decodeHtml"](setting.description)}
                          </Typography>
                          <Stack
                            className="icon-div"
                            spacing={1}
                            direction="row"
                          >
                            {setting.icons?.length === 0 ? (
                              <Typography className="icons" />
                            ) : (
                              setting.icons?.map((icons, key) => {
                                return (
                                  <Typography key={icons} className="icons">
                                    {functions.getIcons(icons)}
                                  </Typography>
                                );
                              })
                            )}
                          </Stack>
                        </Stack>
                      ))}
                  </Box>
                </DialogContent>
              </Dialog>
              <Grid item xs={12} md={3}>
                <Stack direction={"column"}>
                  <BandsPrice
                    isBuilder={isBuilder}
                    stepperNext={handleNext}
                    settingCall={setSettingModalOpen}
                    activeStep={activeStep}
                  />
                  <BandsDetailsTable product={product} />
                  {advertisement && (
                    <DomLink
                      to={{
                        pathname: `${advertisement.alternativeText}`,
                        state: {
                          recentlyViewed: JSON.parse(
                            storage.getSessionStorageItem(
                              "hsRecentlyViewedProducts"
                            )
                          ),
                        },
                      }}
                    >
                      <img
                        style={{ marginTop: "4rem" }}
                        src={`${frontImageUrl}${advertisement.url}`}
                        width="100%"
                        alt="advertisement"
                      />
                    </DomLink>
                  )}
                  {isMdScreen && (
                    <RelatedItems relatedProducts={relatedProducts} />
                  )}
                  {isMdScreen && <RecentlyView />}
                </Stack>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <BandsTechnicalArticles />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomerTestimonials />
              </Grid>
            </Grid>
          </Container>
        )}
      </>
    );
  };

  const renderStepContent = (activeStep) => (
    <Stack spacing={2}>
      {/* Step 0 */}
      <Box
        sx={{
          display:
            activeStep === 0 || activeStep === 1 || activeStep === 3
              ? "block"
              : "none",
        }}
      >
        {renderMainArea()}
      </Box>

      {/* Step 1 */}
      <Box sx={{ display: activeStep === 1 ? "block" : "none" }}></Box>

      {/* Step 2 */}
      <Box sx={{ display: activeStep === 2 ? "block" : "none" }}>
        {setting && activeStep === 2 && (
          <CertDiamondSearchLanding
            isBuilder={isBuilder}
            stepperNext={handleNext}
            stepperBack={handleBack}
            setActiveBandStep={updateStepper}
            productInfo={productInfo}
            setDiamond={updateDiamond}
            settingInfo={setting}
          />
        )}
      </Box>

      {/* Step 3 */}
      <Box sx={{ display: activeStep === 3 ? "block" : "none" }}></Box>

      {/* Step 4 */}
      <Box sx={{ display: activeStep === 4 ? "block" : "none" }}></Box>
    </Stack>
  );

  return (
    <BandsContext.Provider value={{ bandsState, bandsDispatch }}>
      {isBuilder && compatibleSettings && compatibleSettings.length > 0 ? (
        <>
          <Stepper
            activeStep={activeStep}
            orientation="horizontal"
            style={{ display: "none" }}
          >
            {stepsInfo.map((step, index) => (
              <Step key={index} className="stepperTop">
                <StepLabel
                  StepIconComponent={CustomStepIcon}
                  className={`stepperLabel ${
                    activeStep == index ? "stepperActive" : "stepperInactive"
                  }`}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: completedSteps.has(index)
                      ? theme.palette.success.main
                      : activeStep !== index
                      ? theme.palette.primary.default
                      : theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.typography.body1,
                      fontWeight: "bold",
                    }}
                  >
                    {step.name}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          {renderStepContent(activeStep)}
        </>
      ) : (
        renderMainArea()
      )}
    </BandsContext.Provider>
  );
}
